import { createAction } from 'redux-actions'

export const showTypeFormPopup = createAction('TYPE_FORM/SHOW_POPUP')
